(() => {
const C = window.JoffzProductConfigurator;
if (!C) return;
Object.assign(C.prototype, {
resolveFromControls({ updateHistory = true, announce = true, allowClosestSize = false } = {}) {
const material = this.getSelectedMaterial();
const frameInput = this.getSelectedFrameInput(material);
let size = this.getSelectedSize();
if (!material || !frameInput) {
this.renderUnavailable(this.labels.unavailable || this.dataset.messageUnavailable);
return;
}
const finish = frameInput.dataset.nativeFinish;
let variant = this.findVariant(finish, size);
if (!variant && allowClosestSize) {
const closestSize = this.findClosestExistingSize(finish, size, { preferAvailable: true });
if (closestSize) {
this.setSize(closestSize);
size = closestSize;
variant = this.findVariant(finish, size);
}
}
if (!variant) {
this.updateSizeAvailability(finish, size);
this.renderUnavailable(this.labels.unavailable || this.dataset.messageUnavailable);
this.updatePreview({ material, frame: frameInput.value, mount: this.getSelectedMount(), size });
return;
}
this.applyVariant(variant, { updateHistory, announce });
},
applyVariant(variant, { updateHistory = true, replaceHistory = false, announce = true } = {}) {
if (!variant) return;
const state = this.stateFromVariant(variant);
this.currentVariantId = variant.id;
if (state.material === 'paper') {
this.lastPaperFrame = state.frame;
this.lastPaperMount = state.mount;
} else {
this.lastCanvasFrame = state.frame;
}
this.setMaterial(state.material);
this.setFrame(state.material, state.frame);
this.setMount(state.mount);
this.setSize(state.size);
this.updateControlVisibility(state.material, state.frame);
this.updateFrameAvailability(state.material);
this.updateSizeAvailability(variant.options[this.finishOptionKey], state.size);
this.updateNativeVariant(variant);
this.updatePriceAndAvailability(variant);
this.updatePreview(state);
if (updateHistory && !this.isRestoringHistory) {
this.updateUrl(variant.id, replaceHistory);
}
if (announce) {
this.announce(
variant.available
? this.dataset.messageUpdated || ''
: this.labels.soldOut || ''
);
} else {
this.statusElement.textContent = '';
}
this.dispatchEvent(new CustomEvent('joffz:variant-change', {
bubbles: true,
detail: { variant, state },
}));
},
stateFromVariant(variant) {
const finish = String(variant.options[this.finishOptionKey] || '');
const normalizedFinish = this.normalize(finish);
const size = variant.options[this.sizeOptionKey] || this.sizeValues[0] || '';
const isCanvas = normalizedFinish.includes('canvas') || normalizedFinish.includes('floating');
const hasMount =
normalizedFinish.includes('with mount') ||
normalizedFinish.includes('mount yes') ||
normalizedFinish.includes('passepartout');
let material = isCanvas ? 'canvas' : 'paper';
let frame = material === 'canvas' ? 'unframed' : 'print-only';
if (normalizedFinish.includes('black')) frame = 'black';
if (normalizedFinish.includes('oak') || normalizedFinish.includes('natural wood')) frame = 'oak';
if (normalizedFinish.includes('white')) frame = 'white';
if (material === 'paper' && (normalizedFinish === 'poster' || normalizedFinish.includes('print only'))) {
frame = 'print-only';
}
if (material === 'canvas' && !['black', 'oak', 'white'].includes(frame)) {
frame = 'unframed';
}
return {
material,
frame,
mount: material === 'paper' && hasMount ? 'yes' : 'no',
size,
};
},
updateControlVisibility(material, frame) {
const isCanvas = material === 'canvas';
this.paperFrameGroup.hidden = isCanvas;
this.canvasFrameGroup.hidden = !isCanvas;
if (this.canvasNote) this.canvasNote.hidden = !isCanvas;
const showMount = material === 'paper' && frame !== 'print-only';
if (this.mountFieldset) this.mountFieldset.hidden = !showMount;
if (!showMount) this.setMount('no');
this.dataset.material = material;
this.dataset.frame = frame;
this.dataset.mount = this.getSelectedMount() || 'no';
},
updateFrameAvailability(material) {
this.frameInputs.forEach((input) => {
if (input.dataset.materialScope !== material) return;
if (input.dataset.permanentlyDisabled === 'true') {
input.disabled = true;
return;
}
const nativeFinish = input.dataset.nativeFinish;
input.disabled = !this.variants.some(
(variant) => this.normalize(variant.options[this.finishOptionKey]) === this.normalize(nativeFinish)
);
});
},
updateSizeAvailability(finish, selectedSize) {
this.sizeInputs.forEach((input) => {
const variant = this.findVariant(finish, input.value);
const shouldKeepSelectedSoldOut = input.value === selectedSize && Boolean(variant);
input.disabled = !variant || (!variant.available && !shouldKeepSelectedSoldOut);
input.setAttribute('aria-disabled', input.disabled ? 'true' : 'false');
});
},
updateNativeVariant(variant) {
this.isSyncingNativeSelect = true;
this.variantSelect.value = variant.id;
this.variantSelect.disabled = false;
this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
this.isSyncingNativeSelect = false;
}
});
})();
